import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import { getApiUrl } from "../config";
import ForeignDonationStatus from "./ForeignDonationStatus";

const ForeignDonationForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    reset,
  } = useForm({    defaultValues: {
      fullName: "",
      countryOfCitizenship: "",
      passport: "",
      email: "",
      purposeOfDonation: "",
      mobileNumber: "",
      honorName: "",
      honorEmail: "",
      ipAddress: "",
      timestamp: "",
    },
    mode: "onChange"
  });  
  const [isChecked, setIsChecked] = useState(false);
  const [selectedOption, setSelectedOption] = useState("honourOf");
  const [loading, setLoading] = useState(false);
  const [declarationAccepted, setDeclarationAccepted] = useState(false);
  const [statusModal, setStatusModal] = useState({
    open: false,
    status: "",
    message: ""
  });

  const watchedValues = watch();
  const isMobile = window.innerWidth <= 1168;

  // Get user's IP address and timestamp
  useEffect(() => {
    const getIPAddress = async () => {
      try {
        const response = await fetch('https://api.ipify.org?format=json');
        const data = await response.json();
        setValue("ipAddress", data.ip);
      } catch (error) {
        console.error("Error fetching IP address:", error);
        setValue("ipAddress", "Unable to fetch");
      }
    };

    // Set timestamp
    setValue("timestamp", new Date().toISOString());
    
    // Get IP address
    getIPAddress();
  }, [setValue]);

  // Save form data to session storage
  useEffect(() => {
    const savedFormData = sessionStorage.getItem("foreignDonationFormData");
    if (savedFormData) {
      const data = JSON.parse(savedFormData);
      reset(data);
    }
  }, [reset]);

  useEffect(() => {
    sessionStorage.setItem("foreignDonationFormData", JSON.stringify(watchedValues));
  }, [watchedValues]);

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const handleButtonClick = (option) => {
    setSelectedOption(option);
  };
  const handleDeclarationChange = (event) => {
    setDeclarationAccepted(event.target.checked);
  };

  const handlePassportChange = (event) => {
    const value = event.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
    setValue("passport", value);
  };
  const handlePhoneChange = (event) => {
    let value = event.target.value;
    // Ensure it starts with + if user is typing numbers
    if (value && !value.startsWith('+') && /^\d/.test(value)) {
      value = '+' + value;
    }
    setValue("mobileNumber", value);
  };

  const handlePurposeChange = (event) => {
    const value = event.target.value;
    setValue("purposeOfDonation", value);
  };
  const handleFormSubmit = async (data) => {
    setLoading(true);

    try {
      // Prepare payload with IP address and timestamp
      const payload = {
        ...data,
        ipAddress: data.ipAddress,
        timestamp: data.timestamp,
        donationType: "foreign",
        wireTransfer: true,
      };

      console.log("Foreign donation payload:", payload);

      // Send email with wire transfer instructions using the API
      const response = await axios.post(
        getApiUrl("/api/form/email_foreign_donation"),
        payload
      );      if (response.data.status === "success") {
        setStatusModal({
          open: true,
          status: "success",
          message: "Thank you for your donation request! You will receive wire transfer instructions at your email address shortly."
        });
      } else {
        setStatusModal({
          open: true,
          status: "error",
          message: "There was an issue sending the email. Please try again or contact us directly at contactus@soodcharityfoundation.org."
        });
      }
        } catch (error) {
      console.error("Error submitting foreign donation:", error);      setStatusModal({
        open: true,
        status: "error",
        message: "Failed to send email. Please try again or contact us directly at contactus@soodcharityfoundation.org."
      });
    } finally {
      setLoading(false);
    }  };  const handleStatusModalClose = () => {    // Reset the form to default values
    reset({
      fullName: "",
      countryOfCitizenship: "",
      passport: "",
      email: "",
      purposeOfDonation: "",
      mobileNumber: "",
      honorName: "",
      honorEmail: "",
      ipAddress: "",
      timestamp: "",
    });
      // Clear all local state variables
    setIsChecked(false);
    setSelectedOption("honourOf");
    setLoading(false);
    setDeclarationAccepted(false);
    
    // Clear session storage
    sessionStorage.removeItem("foreignDonationFormData");
    
    // Close the modal
    setStatusModal({
      open: false,
      status: "",
      message: ""
    });
      // Hard navigate to home page (with page refresh)
    window.location.href = "/";
  };

  return (
    <div>      {/* Title and Warning Messages */}
      <div style={{ marginBottom: "25px" }}>
        <h2 style={{
          fontSize: "28px",
          fontWeight: "600",
          color: "#00345B",
          marginBottom: "15px"
        }}>
          Foreign Donations Only        </h2>

        {/* Donation Options */}
        {/* <div style={{
          backgroundColor: "#e8f5e8",
          border: "2px solid #28a745",
          borderRadius: "8px",
          padding: "15px",
          margin: "12px 0"
        }}>
          
        </div> */}

        <div style={{
          backgroundColor: "#e3f2fd",
          border: "2px solid #1976d2",
          borderRadius: "8px",
          padding: "15px",
          margin: "12px 0"
        }}>
          <p style={{
            fontSize: "12px",
            fontWeight: "400",
            color: "#000",
            margin: "0 0 8px 0",
            lineHeight: "1.5"
          }}>
            <strong>🇮🇳 Indian Citizens:</strong> If you are an Indian citizen (with Indian passport), you can donate using UPI, Razorpay, or any Indian payment method.
          </p>
          
          <p style={{
            fontSize: "12px",
            fontWeight: "400",
            color: "#000",
            margin: "0 0 8px 0",
            lineHeight: "1.5"
          }}>
            <strong>🌍 Foreign Nationals:</strong> If you are a foreign national (including OCI card holders), please donate via SWIFT transfer to our SBI FCRA account.
          </p>
          <p style={{
            fontSize: "12px",
            fontWeight: "400",
            color: "#000",
            margin: 0,
            lineHeight: "1.6"
          }}>
            <strong>📋 FCRA Compliance:</strong> Your passport number, country of residence, and donation purpose are mandatory to comply with the Foreign Contribution Regulation Act (FCRA), 2010.
          </p>
        </div>

        {/* Validation Help */}

        {/* FCRA Compliance Notice */}
        {/* <div style={{
          backgroundColor: "#fff3cd",
          border: "2px solid #ffc107",
          borderRadius: "8px",
          padding: "15px",
          margin: "15px 0"
        }}>
          
        </div> */}
      </div>      {/* Form */}
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <h3 style={{ marginBottom: "20px", color: "#333" }}>Donation Details</h3>        {/* Full Name */}
        <div className="mb-3">
          <input
            type="text"
            className="form-control"
            placeholder="Full Name *"
            {...register("fullName", {
              required: "Full name is required",
              minLength: {
                value: 2,
                message: "Name must be at least 2 characters long"
              },
              maxLength: {
                value: 50,
                message: "Name cannot exceed 50 characters"
              },
              pattern: {
                value: /^[a-zA-Z\s\-'.]+$/,
                message: "Name can only contain letters, spaces, hyphens, apostrophes, and periods"
              },
              validate: {
                noOnlySpaces: (value) => value.trim().length > 0 || "Name cannot be only spaces",
                noConsecutiveSpaces: (value) => !/\s{2,}/.test(value) || "Name cannot have consecutive spaces"
              }
            })}
          />
          {errors.fullName && (
            <span className="error-text">{errors.fullName.message}</span>
          )}
        </div>{/* Country of Citizenship or Residence */}
        <div className="mb-3">
          <select
            className="form-select"
            {...register("countryOfCitizenship", {
              required: "Country is required"
            })}
          >
            <option value="" style={{ color: "#9ca0a1" }}>
              Select Country of Citizenship or Residence *
            </option>
            <option value="United States">United States</option>
            <option value="Afghanistan">Afghanistan</option>
            <option value="Albania">Albania</option>
            <option value="Algeria">Algeria</option>
            <option value="American Samoa">American Samoa</option>
            <option value="Andorra">Andorra</option>
            <option value="Angola">Angola</option>
            <option value="Anguilla">Anguilla</option>
            <option value="Antartica">Antarctica</option>
            <option value="Antigua and Barbuda">Antigua and Barbuda</option>
            <option value="Argentina">Argentina</option>
            <option value="Armenia">Armenia</option>
            <option value="Aruba">Aruba</option>
            <option value="Australia">Australia</option>
            <option value="Austria">Austria</option>
            <option value="Azerbaijan">Azerbaijan</option>
            <option value="Bahamas">Bahamas</option>
            <option value="Bahrain">Bahrain</option>
            <option value="Bangladesh">Bangladesh</option>
            <option value="Barbados">Barbados</option>
            <option value="Belarus">Belarus</option>
            <option value="Belgium">Belgium</option>
            <option value="Belize">Belize</option>
            <option value="Benin">Benin</option>
            <option value="Bermuda">Bermuda</option>
            <option value="Bhutan">Bhutan</option>
            <option value="Bolivia">Bolivia</option>
            <option value="Bosnia and Herzegowina">Bosnia and Herzegowina</option>
            <option value="Botswana">Botswana</option>
            <option value="Bouvet Island">Bouvet Island</option>
            <option value="Brazil">Brazil</option>
            <option value="British Indian Ocean Territory">British Indian Ocean Territory</option>
            <option value="Brunei Darussalam">Brunei Darussalam</option>
            <option value="Bulgaria">Bulgaria</option>
            <option value="Burkina Faso">Burkina Faso</option>
            <option value="Burundi">Burundi</option>
            <option value="Cambodia">Cambodia</option>
            <option value="Cameroon">Cameroon</option>
            <option value="Canada">Canada</option>
            <option value="Cape Verde">Cape Verde</option>
            <option value="Cayman Islands">Cayman Islands</option>
            <option value="Central African Republic">Central African Republic</option>
            <option value="Chad">Chad</option>
            <option value="Chile">Chile</option>
            <option value="China">China</option>
            <option value="Christmas Island">Christmas Island</option>
            <option value="Cocos Islands">Cocos (Keeling) Islands</option>
            <option value="Colombia">Colombia</option>
            <option value="Comoros">Comoros</option>
            <option value="Congo">Congo</option>
            <option value="Congo">Congo, the Democratic Republic of the</option>
            <option value="Cook Islands">Cook Islands</option>
            <option value="Costa Rica">Costa Rica</option>
            <option value="Cota D'Ivoire">Cote d'Ivoire</option>
            <option value="Croatia">Croatia (Hrvatska)</option>
            <option value="Cuba">Cuba</option>
            <option value="Cyprus">Cyprus</option>
            <option value="Czech Republic">Czech Republic</option>
            <option value="Denmark">Denmark</option>
            <option value="Djibouti">Djibouti</option>
            <option value="Dominica">Dominica</option>
            <option value="Dominican Republic">Dominican Republic</option>
            <option value="East Timor">East Timor</option>
            <option value="Ecuador">Ecuador</option>
            <option value="Egypt">Egypt</option>
            <option value="El Salvador">El Salvador</option>
            <option value="Equatorial Guinea">Equatorial Guinea</option>
            <option value="Eritrea">Eritrea</option>
            <option value="Estonia">Estonia</option>
            <option value="Ethiopia">Ethiopia</option>
            <option value="Falkland Islands">Falkland Islands (Malvinas)</option>
            <option value="Faroe Islands">Faroe Islands</option>
            <option value="Fiji">Fiji</option>
            <option value="Finland">Finland</option>
            <option value="France">France</option>
            <option value="France Metropolitan">France, Metropolitan</option>
            <option value="French Guiana">French Guiana</option>
            <option value="French Polynesia">French Polynesia</option>
            <option value="French Southern Territories">French Southern Territories</option>
            <option value="Gabon">Gabon</option>
            <option value="Gambia">Gambia</option>
            <option value="Georgia">Georgia</option>
            <option value="Germany">Germany</option>
            <option value="Ghana">Ghana</option>
            <option value="Gibraltar">Gibraltar</option>
            <option value="Greece">Greece</option>
            <option value="Greenland">Greenland</option>
            <option value="Grenada">Grenada</option>
            <option value="Guadeloupe">Guadeloupe</option>
            <option value="Guam">Guam</option>
            <option value="Guatemala">Guatemala</option>
            <option value="Guinea">Guinea</option>
            <option value="Guinea-Bissau">Guinea-Bissau</option>
            <option value="Guyana">Guyana</option>
            <option value="Haiti">Haiti</option>
            <option value="Heard and McDonald Islands">Heard and Mc Donald Islands</option>
            <option value="Holy See">Holy See (Vatican City State)</option>
            <option value="Honduras">Honduras</option>
            <option value="Hong Kong">Hong Kong</option>
            <option value="Hungary">Hungary</option>
            <option value="Iceland">Iceland</option>
            <option value="Indonesia">Indonesia</option>
            <option value="Iran">Iran (Islamic Republic of)</option>
            <option value="Iraq">Iraq</option>
            <option value="Ireland">Ireland</option>
            <option value="Israel">Israel</option>
            <option value="Italy">Italy</option>
            <option value="Jamaica">Jamaica</option>
            <option value="Japan">Japan</option>
            <option value="Jordan">Jordan</option>
            <option value="Kazakhstan">Kazakhstan</option>
            <option value="Kenya">Kenya</option>
            <option value="Kiribati">Kiribati</option>
            <option value="Democratic People's Republic of Korea">Korea, Democratic People's Republic of</option>
            <option value="Korea">Korea, Republic of</option>
            <option value="Kuwait">Kuwait</option>
            <option value="Kyrgyzstan">Kyrgyzstan</option>
            <option value="Lao">Lao People's Democratic Republic</option>
            <option value="Latvia">Latvia</option>
            <option value="Lebanon">Lebanon</option>
            <option value="Lesotho">Lesotho</option>
            <option value="Liberia">Liberia</option>
            <option value="Libyan Arab Jamahiriya">Libyan Arab Jamahiriya</option>
            <option value="Liechtenstein">Liechtenstein</option>
            <option value="Lithuania">Lithuania</option>
            <option value="Luxembourg">Luxembourg</option>
            <option value="Macau">Macau</option>
            <option value="Macedonia">Macedonia, The Former Yugoslav Republic of</option>
            <option value="Madagascar">Madagascar</option>
            <option value="Malawi">Malawi</option>
            <option value="Malaysia">Malaysia</option>
            <option value="Maldives">Maldives</option>
            <option value="Mali">Mali</option>
            <option value="Malta">Malta</option>
            <option value="Marshall Islands">Marshall Islands</option>
            <option value="Martinique">Martinique</option>
            <option value="Mauritania">Mauritania</option>
            <option value="Mauritius">Mauritius</option>
            <option value="Mayotte">Mayotte</option>
            <option value="Mexico">Mexico</option>
            <option value="Micronesia">Micronesia, Federated States of</option>
            <option value="Moldova">Moldova, Republic of</option>
            <option value="Monaco">Monaco</option>
            <option value="Mongolia">Mongolia</option>
            <option value="Montserrat">Montserrat</option>
            <option value="Morocco">Morocco</option>
            <option value="Mozambique">Mozambique</option>
            <option value="Myanmar">Myanmar</option>
            <option value="Namibia">Namibia</option>
            <option value="Nauru">Nauru</option>
            <option value="Nepal">Nepal</option>
            <option value="Netherlands">Netherlands</option>
            <option value="Netherlands Antilles">Netherlands Antilles</option>
            <option value="New Caledonia">New Caledonia</option>
            <option value="New Zealand">New Zealand</option>
            <option value="Nicaragua">Nicaragua</option>
            <option value="Niger">Niger</option>
            <option value="Nigeria">Nigeria</option>
            <option value="Niue">Niue</option>
            <option value="Norfolk Island">Norfolk Island</option>
            <option value="Northern Mariana Islands">Northern Mariana Islands</option>
            <option value="Norway">Norway</option>
            <option value="Oman">Oman</option>
            <option value="Pakistan">Pakistan</option>
            <option value="Palau">Palau</option>
            <option value="Panama">Panama</option>
            <option value="Papua New Guinea">Papua New Guinea</option>
            <option value="Paraguay">Paraguay</option>
            <option value="Peru">Peru</option>
            <option value="Philippines">Philippines</option>
            <option value="Pitcairn">Pitcairn</option>
            <option value="Poland">Poland</option>
            <option value="Portugal">Portugal</option>
            <option value="Puerto Rico">Puerto Rico</option>
            <option value="Qatar">Qatar</option>
            <option value="Reunion">Reunion</option>
            <option value="Romania">Romania</option>
            <option value="Russia">Russian Federation</option>
            <option value="Rwanda">Rwanda</option>
            <option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option>
            <option value="Saint Lucia">Saint LUCIA</option>
            <option value="Saint Vincent">Saint Vincent and the Grenadines</option>
            <option value="Samoa">Samoa</option>
            <option value="San Marino">San Marino</option>
            <option value="Sao Tome and Principe">Sao Tome and Principe</option>
            <option value="Saudi Arabia">Saudi Arabia</option>
            <option value="Senegal">Senegal</option>
            <option value="Seychelles">Seychelles</option>
            <option value="Sierra">Sierra Leone</option>
            <option value="Singapore">Singapore</option>
            <option value="Slovakia">Slovakia (Slovak Republic)</option>
            <option value="Slovenia">Slovenia</option>
            <option value="Solomon Islands">Solomon Islands</option>
            <option value="Somalia">Somalia</option>
            <option value="South Africa">South Africa</option>
            <option value="South Georgia">South Georgia and the South Sandwich Islands</option>
            <option value="Span">Spain</option>
            <option value="Sri Lanka">Sri Lanka</option>
            <option value="St. Helena">St. Helena</option>
            <option value="St. Pierre and Miguelon">St. Pierre and Miquelon</option>
            <option value="Sudan">Sudan</option>
            <option value="Suriname">Suriname</option>
            <option value="Svalbard">Svalbard and Jan Mayen Islands</option>
            <option value="Swaziland">Swaziland</option>
            <option value="Sweden">Sweden</option>
            <option value="Switzerland">Switzerland</option>
            <option value="Syria">Syrian Arab Republic</option>
            <option value="Taiwan">Taiwan, Province of China</option>
            <option value="Tajikistan">Tajikistan</option>
            <option value="Tanzania">Tanzania, United Republic of</option>
            <option value="Thailand">Thailand</option>
            <option value="Togo">Togo</option>
            <option value="Tokelau">Tokelau</option>
            <option value="Tonga">Tonga</option>
            <option value="Trinidad and Tobago">Trinidad and Tobago</option>
            <option value="Tunisia">Tunisia</option>
            <option value="Turkey">Turkey</option>
            <option value="Turkmenistan">Turkmenistan</option>
            <option value="Turks and Caicos">Turks and Caicos Islands</option>
            <option value="Tuvalu">Tuvalu</option>
            <option value="Uganda">Uganda</option>
            <option value="Ukraine">Ukraine</option>
            <option value="United Arab Emirates">United Arab Emirates</option>
            <option value="United Kingdom">United Kingdom</option>
            <option value="United States Minor Outlying Islands">United States Minor Outlying Islands</option>
            <option value="Uruguay">Uruguay</option>
            <option value="Uzbekistan">Uzbekistan</option>
            <option value="Vanuatu">Vanuatu</option>
            <option value="Venezuela">Venezuela</option>
            <option value="Vietnam">Viet Nam</option>
            <option value="Virgin Islands (British)">Virgin Islands (British)</option>
            <option value="Virgin Islands (U.S)">Virgin Islands (U.S.)</option>
            <option value="Wallis and Futana Islands">Wallis and Futuna Islands</option>
            <option value="Western Sahara">Western Sahara</option>
            <option value="Yemen">Yemen</option>
            <option value="Serbia">Serbia</option>
            <option value="Zambia">Zambia</option>
            <option value="Zimbabwe">Zimbabwe</option>
          </select>          {errors.countryOfCitizenship && (
            <span className="error-text">{errors.countryOfCitizenship.message}</span>
          )}
        </div>        {/* Passport Number */}
        <div className="mb-3">
          <input
            type="text"
            className="form-control"
            placeholder="Passport number *"
            {...register("passport", {
              required: "Passport number is required",
              minLength: {
                value: 6,
                message: "Passport number must be at least 6 characters long"
              },
              maxLength: {
                value: 15,
                message: "Passport number cannot exceed 15 characters"
              },
              pattern: {
                value: /^[A-Z0-9]+$/,
                message: "Passport number can only contain uppercase letters and numbers"
              },
              validate: {
                noSpaces: (value) => !/\s/.test(value) || "Passport number cannot contain spaces"
              }
            })}
            onChange={handlePassportChange}
          />
          {errors.passport && (
            <span className="error-text">{errors.passport.message}</span>
          )}
        </div>{/* Email Address */}
        <div className="mb-3">
          <input
            type="email"
            className="form-control"
            placeholder="Email *"
            {...register("email", {
              required: "Email is required",
              pattern: {
                value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                message: "Please enter a valid email address"
              },
              validate: {
                noConsecutiveDots: (value) => !/\.{2,}/.test(value) || "Email cannot have consecutive dots",
                validDomain: (value) => {
                  const domain = value.split('@')[1];
                  if (!domain) return "Invalid email format";
                  return /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(domain) || "Invalid domain format";
                },
                noSpaces: (value) => !/\s/.test(value) || "Email cannot contain spaces"
              }
            })}
          />
          {errors.email && (
            <span className="error-text">{errors.email.message}</span>
          )}
        </div>        {/* Purpose of Donation */}
        <div className="mb-3">
          <textarea
            className="form-control"
            rows="3"
            placeholder="Purpose of Donation *"
            {...register("purposeOfDonation", {
              required: "Purpose of donation is required",
              minLength: {
                value: 10,
                message: "Purpose must be at least 10 characters long"
              },
              maxLength: {
                value: 500,
                message: "Purpose cannot exceed 500 characters"
              },
              validate: {
                noOnlySpaces: (value) => value.trim().length > 0 || "Purpose cannot be only spaces",
                meaningfulContent: (value) => {
                  const trimmed = value.trim();
                  if (trimmed.length < 10) return "Please provide a more detailed purpose";
                  return true;
                }
              }
            })}
            onChange={handlePurposeChange}
          />
          {errors.purposeOfDonation && (
            <span className="error-text">{errors.purposeOfDonation.message}</span>
          )}
        </div>{/* Mobile Number */}
        <div className="mb-3">
          <input
            type="tel"
            className="form-control"
            placeholder="Mobile number (with country code, e.g., +1234567890) *"
            {...register("mobileNumber", {
              required: "Mobile number is required",
              pattern: {
                value: /^\+[1-9]\d{1,14}$/,
                message: "Please enter a valid international phone number starting with + (e.g., +1234567890)"
              },
              validate: {
                minLength: (value) => value.length >= 8 || "Phone number too short",
                maxLength: (value) => value.length <= 16 || "Phone number too long",
                validCountryCode: (value) => {
                  const countryCode = value.substring(1, 4);
                  return /^\d+$/.test(countryCode) || "Invalid country code";
                }
              }
            })}
            onChange={handlePhoneChange}
          />
          {errors.mobileNumber && (
            <span className="error-text">{errors.mobileNumber.message}</span>
          )}
        </div>

        {/* Dedicate this donation section */}
        <div className="mb-3">
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="dedicateCheck"
              checked={isChecked}
              onChange={handleCheckboxChange}
            />
            <label className="form-check-label" htmlFor="dedicateCheck">
              <b>Dedicate this donation</b>
            </label>
          </div>
          
          {isChecked && (
            <div>
              <div className="mb-3 mt-3">
                <button
                  type="button"
                  className="btn"
                  onClick={() => handleButtonClick("honourOf")}
                  style={{
                    background: selectedOption === "honourOf" ? "#00345B" : "",
                    color: selectedOption === "honourOf" ? "white" : "",
                    borderRadius: "50px",
                    padding: "12px 50px",
                    minWidth: "17%",
                    textAlign: "center",
                    borderColor: selectedOption === "honourOf" ? "#00345B" : "#007bff",
                    marginRight: !isMobile ? "2%" : 0,
                    marginBottom: isMobile ? "10px" : 0,
                  }}
                >
                  <b>In Honour Of</b>
                </button>
                <button
                  type="button"
                  className="btn"
                  onClick={() => handleButtonClick("memoryOf")}
                  style={{
                    background: selectedOption === "memoryOf" ? "#00345B" : "",
                    color: selectedOption === "memoryOf" ? "white" : "",
                    borderRadius: "50px",
                    padding: "12px 40px",
                    minWidth: "17%",
                    textAlign: "center",
                    marginLeft: !isMobile ? "2%" : 0,
                    borderColor: selectedOption === "memoryOf" ? "#00345B" : "#007bff",
                  }}
                >
                  <b>In Memory Of</b>
                </button>
              </div>              {selectedOption === "honourOf" && (
                <div>
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Dedicatee's Name *"
                      {...register("honorName", {
                        validate: (value) => {
                          if (isChecked && !value) {
                            return "Dedicatee name is required";
                          }
                          if (isChecked && value && value.trim().length < 2) {
                            return "Name must be at least 2 characters long";
                          }
                          if (isChecked && value && value.length > 50) {
                            return "Name cannot exceed 50 characters";
                          }
                          if (isChecked && value && !/^[a-zA-Z\s\-'.]+$/.test(value)) {
                            return "Name can only contain letters, spaces, hyphens, apostrophes, and periods";
                          }
                          if (isChecked && value && value.trim().length === 0) {
                            return "Name cannot be only spaces";
                          }
                          return true;
                        }
                      })}
                    />
                    {errors.honorName && (
                      <span className="error-text">{errors.honorName.message}</span>
                    )}
                  </div>
                  <div className="mb-3">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Notify by Email *"
                      {...register("honorEmail", {
                        validate: (value) => {
                          if (isChecked && selectedOption === "honourOf" && !value) {
                            return "Email is required for notification";
                          }
                          if (value && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {
                            return "Please enter a valid email address";
                          }
                          if (value && /\.{2,}/.test(value)) {
                            return "Email cannot have consecutive dots";
                          }
                          if (value && /\s/.test(value)) {
                            return "Email cannot contain spaces";
                          }
                          return true;
                        }
                      })}
                    />
                    {errors.honorEmail && (
                      <span className="error-text">{errors.honorEmail.message}</span>
                    )}
                  </div>
                </div>
              )}              {selectedOption === "memoryOf" && (
                <div>
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Dedicatee's Name *"
                      {...register("honorName", {
                        validate: (value) => {
                          if (isChecked && !value) {
                            return "Dedicatee name is required";
                          }
                          if (isChecked && value && value.trim().length < 2) {
                            return "Name must be at least 2 characters long";
                          }
                          if (isChecked && value && value.length > 50) {
                            return "Name cannot exceed 50 characters";
                          }
                          if (isChecked && value && !/^[a-zA-Z\s\-'.]+$/.test(value)) {
                            return "Name can only contain letters, spaces, hyphens, apostrophes, and periods";
                          }
                          if (isChecked && value && value.trim().length === 0) {
                            return "Name cannot be only spaces";
                          }
                          return true;
                        }
                      })}
                    />
                    {errors.honorName && (
                      <span className="error-text">{errors.honorName.message}</span>
                    )}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>        {/* Declaration */}
        <div className="mb-4" style={{
          backgroundColor: "#f8f9fa",
          padding: "15px",
          borderRadius: "8px",
          border: "1px solid #dee2e6"
        }}>
          <h4 style={{ color: "#00345B", marginBottom: "12px", fontSize: "18px" }}>Declaration</h4>
          
          <div style={{ fontSize: "13px", lineHeight: "1.5", color: "#666", marginBottom: "12px" }}>
            <p style={{ marginBottom: "8px", fontWeight: "500" }}>I understand and accept that:</p>            <ul style={{ margin: "0 0 0 15px", padding: "0" }}>
              <li style={{ marginBottom: "5px" }}>I am a foreign donor (non-Indian citizen/resident)</li>
              <li style={{ marginBottom: "5px" }}>This contribution is from a foreign source in compliance with FCRA, 2010</li>
              <li style={{ marginBottom: "5px" }}>All information provided is true, accurate, and complete</li>
              <li style={{ marginBottom: "5px" }}>I accept the{" "}
                <a 
                  href="https://www.soodcharityfoundation.org/privacy-policy" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{ color: "#00345B", textDecoration: "underline" }}
                >
                  Privacy Policy
                </a>
                {" "}and{" "}
                <a 
                  href="https://www.soodcharityfoundation.org/term-and-condition" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{ color: "#00345B", textDecoration: "underline" }}
                >
                  Terms and Conditions
                </a>
              </li>
            </ul>
          </div>
          
          <div style={{ 
            fontSize: "13px", 
            color: "#00345B", 
            backgroundColor: "#e3f2fd",
            padding: "10px",
            borderRadius: "5px",
            marginBottom: "12px",
            lineHeight: "1.4"
          }}>
            <strong>Next Steps:</strong> You will receive wire transfer instructions at 
            donation@soodcharityfoundation.org to ensure secure, verified donations.
          </div>

          <div className="form-check">
            <input
              type="checkbox"
              id="declarationAccepted"
              className="form-check-input"
              checked={declarationAccepted}
              onChange={handleDeclarationChange}
              required
            />
            <label className="form-check-label" htmlFor="declarationAccepted" style={{ fontSize: "13px" }}>
              <strong>I accept and confirm the above declaration.</strong>
            </label>
          </div>
          {!declarationAccepted && (
            <span className="error-text" style={{ display: "block", marginTop: "5px", fontSize: "12px" }}>
              Please accept the declaration to proceed.
            </span>
          )}
        </div>

        {/* Submit Button */}
        <div className="d-grid gap-2">
          <button
            type="submit"
            className="btn btn-primary"
            disabled={!declarationAccepted || loading}
            style={{
              background: declarationAccepted ? "#00345B" : "#ccc",
              borderRadius: "40px",
              padding: "15px",
              fontSize: "18px",
              fontWeight: "600",
              border: "none"
            }}
          >
            {loading ? "Processing..." : "Donate"}
          </button>
        </div>

        {loading && (
          <div className="loading" style={{ textAlign: "center", marginTop: "20px" }}>
            <div>Processing your request...</div>
          </div>        )}
      </form>      <ForeignDonationStatus
        open={statusModal.open}
        onClose={handleStatusModalClose}
        status={statusModal.status}
        message={statusModal.message}
      />
    </div>
  );
};

export default ForeignDonationForm;
